import { getAxiosInstance } from '@/services/axiosConfig';
import { log } from '@/logger/logger';
import type { ApiObject } from '@/types/analytics.types';

const logger = log.getLogger('WeavyAnalytics');

// Weavy Analytics - Custom BI events implementation
class WeavyAnalytics {
  async track(event: string, properties: ApiObject | null): Promise<void> {
    try {
      const axiosInstance = getAxiosInstance();
      await axiosInstance.post('/bi/track', {
        eventName: event,
        properties: properties || {},
      });
    } catch (error) {
      logger.error('Failed to track event:', error);
    }
  }

  async identify(): Promise<void> {
    try {
      const axiosInstance = getAxiosInstance();
      await axiosInstance.post('/bi/identify');
    } catch (error) {
      logger.error('Failed to identify user:', error);
    }
  }
}

const weavyAnalytics = new WeavyAnalytics();

export { weavyAnalytics };
